"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimelineSpriteCues = exports.parseSpriteVTT = exports.parseCue = exports.parseImage = exports.parseDimensions = void 0;
const url_toolkit_1 = require("url-toolkit");
const webvtt_parser_1 = require("webvtt-parser");
/**
 * parse dimensions from the string image.jpg#xywh=0,0,160,90
 * into {IDimensions}
 * @param  {string}      text
 * @return {IDimensions}
 */
function parseDimensions(text) {
    var _a;
    const values = (_a = text.split("#xywh=")[1]) === null || _a === void 0 ? void 0 : _a.split(",");
    if (values && values.length === 4) {
        return {
            x: parseInt(values[0], 10),
            y: parseInt(values[1], 10),
            width: parseInt(values[2], 10),
            height: parseInt(values[3], 10),
        };
    }
}
exports.parseDimensions = parseDimensions;
/**
 * parse image URL from the VTT text "image.jpg#xywh=0,0,160,90"
 * into an absolute url
 * @param  {string} text
 * @param  {string} vttUrl the VTT url which text string originates from
 * @return {string}
 */
function parseImage(text, vttUrl) {
    if (text) {
        return (0, url_toolkit_1.buildAbsoluteURL)(vttUrl, text.split("#")[0]);
    }
    return null;
}
exports.parseImage = parseImage;
function parseCue(cue, vttUrl, offset) {
    const image = parseImage(cue.text, vttUrl);
    const dimensions = parseDimensions(cue.text);
    if (!image || !dimensions) {
        return;
    }
    return {
        start: cue.startTime - offset,
        end: cue.endTime - offset,
        image,
        dimensions,
    };
}
exports.parseCue = parseCue;
function parseSpriteVTT(vtt, vttUrl, offset) {
    const parser = new webvtt_parser_1.WebVTTParser();
    const { cues } = parser.parse(vtt);
    return cues
        .map((cue) => parseCue(cue, vttUrl, offset))
        .filter((cue) => cue !== undefined);
}
exports.parseSpriteVTT = parseSpriteVTT;
function getTimelineSpriteCues(vttUrl, offset) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(vttUrl);
        const vtt = yield response.text();
        return parseSpriteVTT(vtt, vttUrl, offset);
    });
}
exports.getTimelineSpriteCues = getTimelineSpriteCues;
//# sourceMappingURL=index.js.map